import { render, staticRenderFns } from "./BarcodeScannerCamera.vue?vue&type=template&id=cbec480a&scoped=true&"
import script from "./BarcodeScannerCamera.vue?vue&type=script&lang=js&"
export * from "./BarcodeScannerCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbec480a",
  null
  
)

export default component.exports